/**
 * Reduce a URL to scheme + host + path for logging, dropping query strings, fragments, userinfo
 * and matrix params. Host and base path are kept — that is what CSP triage needs.
 *
 * Rebuild from parsed pieces rather than stripping known-bad parts. The stripping version
 * (`split('?')[0]`) leaked an Okta code that was percent-encoded inside a path, with no literal
 * `?` in the URL at all; see sanitizeLoggedUrl.test.js for that URL and the Security note in
 * docs/csp-hardening-plan.md.
 */
export const sanitizeLoggedUrl = (value) => {
  if (typeof value !== 'string' || !value) {
    return value;
  }
  try {
    const { protocol, host, pathname } = new URL(value);
    // Matrix params: `/activity;src=…;~oref=<encoded url>` -> `/activity`. Also kills `;jsessionid=`.
    const path = pathname
      .split('/')
      .map((segment) => segment.split(';')[0])
      .join('/');
    // `host` not `hostname`: keeps a non-default port, drops `user:pass@`.
    return host ? `${protocol}//${host}${path}` : `${protocol}${path}`;
  } catch {
    // Non-URL blockedURI values ('eval', 'inline', 'data', 'ms-browser-extension'). Already safe,
    // but cut at any query/fragment marker in case an unparseable value carries one.
    return value.split(/[?#]|%3[Ff]/)[0];
  }
};
